import React from 'react';

export function ContactKvkk() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl font-bold mb-6">İletişim Formu KVKK Aydınlatma Metni</h1>
      <p className="text-muted-foreground mb-4">
        6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında, İlimera Teknoloji Yazılım LTD. ŞTİ.
        ("İlimera" veya "Şirket") olarak iletişim formu üzerinden ilettiğiniz kişisel verilerinizi aşağıda açıklanan
        amaçlar ve hukuki sebepler doğrultusunda işlemekteyiz.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">İşlenen Kişisel Veriler</h2>
      <p className="mb-4">Ad-soyad, e‑posta, telefon, konu ve mesaj içeriği.</p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">İşleme Amaçları</h2>
      <ul className="list-disc pl-6 space-y-1 mb-4">
        <li>Taleplerinize dönüş yapılması ve iletişimin sağlanması</li>
        <li>Tekliflendirme ve müşteri ilişkileri süreçlerinin yürütülmesi</li>
        <li>Hukuki yükümlülüklerin yerine getirilmesi ve olası uyuşmazlıklarda ispat</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Hukuki Sebepler</h2>
      <p className="mb-4">
        KVKK m.5/2 (c), (ç) ve (f): sözleşmenin kurulması/ifası, hukuki yükümlülük, meşru menfaat.
        Pazarlama/iletişim izni vermeniz halinde KVKK m.5/1 kapsamında açık rızanız.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Aktarımlar</h2>
      <p className="mb-4">
        Barındırma, e‑posta/SMS ve BT altyapı hizmeti sağlayıcıları ile sınırlı olarak paylaşılabilir; yasal talepler
        halinde yetkili mercilere aktarılabilir.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Saklama Süresi</h2>
      <p className="mb-4">İşleme amacının gerektirdiği süre ve ilgili mevzuattaki zamanaşımı süreleri boyunca.</p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Haklarınız</h2>
      <p className="mb-4 text-sm">
        KVKK m.11 kapsamındaki haklarınızı kullanmak için bizimle iletişime geçebilirsiniz.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">İletişim</h2>
      <div className="space-y-3 text-sm">
        <div><strong>Unvan:</strong> İlimera Teknoloji Yazılım LTD. ŞTİ.</div>
        <div><strong>E‑posta:</strong> info@ilimera.com</div>
        <div><strong>Genel Merkez:</strong> Akdeniz Üniversitesi, Teknokent Uluğbey ArGe-2 No:3A/B96 Konyaaltı / ANTALYA</div>
        <div><strong>Ar-Ge Merkezi:</strong> Davraz Mah. 104. Cadde No:44-A Kat:2 Ofis:13/1, Merkez / ISPARTA</div>
      </div>

      <p className="text-xs text-muted-foreground mt-8">
        Bu metin bilgilendirme amaçlıdır; güncel mevzuat ve şirket süreçlerinize göre hukuk danışmanınızla
        gözden geçirmenizi öneririz.
      </p>
    </div>
  );
}


